import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel } from '@material-ui/core';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { setSelectedServiceId, setSelectedStageId, getCRCTaskPickerEmail, getcrcPickerEmail } from '../../store/actions/index';
import MyModal from './Modal';
import FormDialog from '../../../../components/table/FormDialog';
import CommentDeleting from '../OpenService/CommentDeleting';
import '../../servicestyles.css';
import { CommonConfig } from '../../../../config/common-config';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { render } from '@testing-library/react';
import { userType } from '../../../../config/usertypeValue';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Download } from '../ClosedService/downloadpdf';
import { SelectAllRounded } from '@material-ui/icons';
import { useLocation, useParams } from 'react-router-dom';

function EnhancedTableHead(props) {
    const { classes, headcells, order, orderBy, onRequestSort, action, Reports } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const usertype = userDetails.result && userDetails.result.data.userType;
    const usertypeBranchName = userDetails.result && userDetails.result.data.features[0].branchName;

    return (
        <TableHead size="medium" className={classes.thead}>
            <TableRow>
                {headcells.map((headRow) => {
                    return (
                        <TableCell
                            className={classes.TableHeadCss}
                            key={headRow.id}
                            align="left"
                            sortDirection={orderBy === headRow.id ? order : false}
                        >
                            <TableSortLabel
                                active={orderBy === headRow.id}
                                direction={orderBy === headRow.id ? order : 'asc'}
                                onClick={createSortHandler(headRow.id)}
                            >
                                {headRow.label}
                                {orderBy === headRow.id ? (
                                    <span className={classes.visuallyHidden}>
                                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}{' '}
                                    </span>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    );
                })}
                {usertype === 'itec' || usertypeBranchName === 'Other employee users'
                    ? ''
                    : action && (
                          <TableCell align="left" className={classes.TableHeadCss}>
                              Action
                          </TableCell>
                      )}
                {usertype === 'SUPERADMIN' || usertype === 'ITeC AM and above' || usertype === 'ITeC Team' || usertype === 'itec'
                    ? ''
                    : Reports && (
                          <TableCell align="left" className={classes.TableHeadCss}>
                              Reports
                          </TableCell>
                      )}
            </TableRow>
        </TableHead>
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
        padding: theme.spacing(2),
    },
    thead: {
        fontSize: 16,
        backgroundColor: 'gainsboro',
    },
    tableRow: {
        height: '50px',
    },
    TableHeadCss: {
        fontWeight: '700',
        fontFamily: 'Rubik',
        fontSize: '14px',
        color: '#31333F',
        backgroundColor: '#dcdcdc',
    },
    red: {
        backgroundColor: 'red',
        color: 'white',
        borderRadius: '3px',
        padding: '3px 10px',
        textTransform: 'capitalize',
        fontFamily: 'Rubik',
    },
    green: {
        backgroundColor: 'green',
        color: 'white',
        borderRadius: '3px',
        padding: '3px 6px',
        textTransform: 'capitalize',
        fontFamily: 'Rubik',
    },
    grey: {
        backgroundColor: 'grey',
        color: 'white',
        borderRadius: '3px',
        padding: '3px 6px',
        textTransform: 'capitalize',
        fontFamily: 'Rubik',
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    textSize: {
        fontSize: '10px !important',
        padding: '16px 18px !important',
    },
    textSizeforcrc: {
        fontSize: '6px !important',
        padding: '16px 18px !important',
    },

    tblAction: {
        '& button': {
            padding: '0',
            paddingRight: '10px',
            '&:last-child': {
                paddingRight: '0px',
            },
            '&:hover': {
                backgroundColor: 'transparent',
            },
        },
    },
}));

function descendingComparator(a, b, orderBy) {
    const x = typeof a[orderBy] === 'string' ? a[orderBy].toLowerCase() : a[orderBy];
    const y = typeof b[orderBy] === 'string' ? b[orderBy].toLowerCase() : b[orderBy];

    if (y < x) {
        return -1;
    }
    if (x < y) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);

    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);

        if (order !== 0) return order;

        return a[1] - b[1];
    });

    return stabilizedThis.map((el) => {
        return el[0];
    });
}

const ServiceTable = (props) => {
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('');
    const [test, setTest] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const userTeam = userDetails.result && userDetails.result.data.features[0].team;
    const branchName = userDetails.result && userDetails.result.data.features[0].branchName;
    const serviceIdSelected = useSelector((state) => state.serviceCheckListReducer.serviceIdSelected);
    const usertypeBranchName = userDetails.result && userDetails.result.data.features[0].branchName;

    // console.log("serviceIdSelected", serviceIdSelected);

    // const crcTaskPickerEmail = useSelector((state) => state.serviceCheckListReducer.crcTaskPickerEmail);
    // console.log("crcTaskPickerEmail", crcTaskPickerEmail);

    // const crcPickerEmail = useSelector((state) => state.serviceCheckListReducer.crcPickerEmail);
    // console.log("crcPickerEmail", crcPickerEmail);
    const imcNameSelected = useSelector((state) => state.serviceCheckListReducer.imcNameSelected);
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const usertype = userDetails.result && userDetails.result.data.userType;
    const [open1, setOpen1] = React.useState(false);
    const [OpenForItecCRC, setOpenForItecCRC] = React.useState(false);
    const [OpenForItecAM, setOpenForItecAM] = React.useState(false);
    const [OpenForItecOthers, setOpenForItecOthers] = React.useState(false);
    const username = userDetails.result && userDetails.result.data.userName;

    const {
        headcells,
        action,
        rows,
        service,
        post,
        handleDelete,
        pageName,
        handleClickRow,
        handleCount,
        pageDetails,
        prvnxtbt,
        handleRerender,
        Reports,
        selectedImc,
    } = props;

    const [isOpen, setIsOpen] = useState(false);
    const history = useHistory();
    const dispatch = useDispatch({});
    const [ItecUsers, setItecUsers] = useState([]);
    const [CRCEmail, setCRCEmail] = useState([]);
    const [paidTax, setPaidTax] = useState('');

    // console.log("CRCEmail", CRCEmail);

    // const checkListCRCEmail = CRCEmail.checkList;
    // console.log("checkListCRCEmail", checkListCRCEmail);

    // const crcTaskPickerEmail = checkListCRCEmail && checkListCRCEmail.crcTaskPickerEmail
    // console.log("crcTaskPickerEmail", crcTaskPickerEmail);

    function Alert(props1) {
        return <MuiAlert elevation={6} variant="filled" {...props1} />;
    }
    const [open, setOpen] = React.useState(false);
    const [popUpDisplayMessage, setpopUpDisplayMessage] = React.useState('loading...');
    const [popUpDisplayType, setpopUpDisplayType] = React.useState('info');
    const [itecMembers, setItecMembers] = React.useState([]);
    const [crcPickerName, setCRCPickerName] = React.useState('');
    const [amPickerName, setAMPickerName] = React.useState('');
    const [itecOthersPickerName, setItecOthersPickerName] = React.useState('');

    const handleClick = () => {
        setOpen(true);
    };

    const handleClose = (reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);
    const classes = useStyles();

    const handleRequestSort = (property) => {
        let targetID;

        if (property.currentTarget.innerText === 'Client ID') {
            targetID = 'clientId';
        } else if (property.currentTarget.innerText === 'Client name') {
            targetID = 'clientName';
        } else if (property.currentTarget.innerText === 'Service ID') {
            targetID = 'serviceId';
        } else if (property.currentTarget.innerText === 'Client type') {
            targetID = 'clientType';
        }
        const isAsc = orderBy === targetID && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(targetID);
    };

    const axiosConfig = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            Authorization: bearerToken,
            Accept: '*/*',
        },
    };

    const openConfirmationDialog = () => {
        setOpen1(true);
    };

    const closeConfirmationDialog = () => {
        setOpen1(false);
        handleRerender();
    };

    const openConfirmationDialogForItecCRC = () => {
        setOpenForItecCRC(true);
    };
    const closeConfirmationDialogForItecCRC = () => {
        setOpenForItecCRC(false);
        handleRerender();
    };

    const openConfirmationDialogForItecAM = () => {
        setOpenForItecAM(true);
    };

    const closeConfirmationDialogForItecAM = () => {
        setOpenForItecAM(false);
        handleRerender();
    };

    const openConfirmationDialogForItecOthers = () => {
        setOpenForItecOthers(true);
    };

    const closeConfirmationDialogForItecOthers = () => {
        setOpenForItecOthers(false);
        handleRerender();
    };

    const crcPickerServices = (serviceIdSelect) => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/services/${selectedImc}?page=0&size=10000`, axiosConfig)
            .then((response) => {
                response.data.content.filter((dataValue, i) => {
                    // console.log("dataValue for crcemail", dataValue);
                    // console.log("serviceIdSelect", serviceIdSelect);

                    if (dataValue.serviceId === serviceIdSelect) {
                        // console.log("dataValue for crcemailifloop", dataValue);
                        setCRCPickerName(dataValue.checkList.crcPickerFirstName);
                    }
                });
            })
            .catch(() => {});
    };

    const handleCloseDialog = () => {
        setIsOpen(false);
    };

    const actionButton = (actionButtonData) => {
        // console.log("actionButtonData", actionButtonData.taskpickerdetailsfromstageID5);
        console.log('actionButtonData', actionButtonData);
        const statusIDValue = actionButtonData.servId;
        userType.historyStageId = actionButtonData.statusId;
        dispatch(setSelectedServiceId(actionButtonData.servId));
        dispatch(setSelectedStageId(actionButtonData.statusId));

        if (actionButtonData.statusId === 3 || 7) {
            crcPickerServices(actionButtonData.servId);
        }

        if (actionButtonData.statusId === 1 && actionButtonData.serviceTypeText === 'INCORPORATION') {
            history.push(`/menu/incorporationFlow?service_id=${actionButtonData.servId}`);
        } else {
            history.push('/menu/checkListGenerator');
        }

        // if (actionButtonData.statusId === 1) {
        //     history.push('/menu/checkListGenerator');
        // }

        if (actionButtonData.statusId === 3) {
            const data = {
                serviceId: statusIDValue,
            };
            userType.value = 'L1 CRC Confirmed';
            // console.log("chklistData: ", chklistData);

            axios
                .put(`${CommonConfig.dev.baseUrl1}/api/itr/checklist/crc-start-relevance/${imcNameSelected}`, data, axiosConfig)
                .then((response) => {
                    history.push({
                        pathname: '/menu/crc-checklist',
                        state: { statusIDValue },
                    });
                })
                .catch((error) => {
                    // console.log("errror: ", error.response);
                    if (
                        error &&
                        error.response &&
                        error.response.data &&
                        error.response.data.message === 'Checklist Id or Service Id does not exist or stage mis-match'
                    ) {
                        openConfirmationDialogForItecCRC();
                    } else {
                        setpopUpDisplayMessage(error.response.data.message);
                        setpopUpDisplayType('error');
                        handleClick();
                    }
                });
        }
        if (actionButtonData.statusId === 7) {
            const chklistData = {
                serviceId: serviceIdSelected,
            };
            userType.value = 'L2 CRC Confirmed';

            axios
                .put(`${CommonConfig.dev.baseUrl1}/api/itr/checklist/crc-start-relevance/${imcNameSelected}`, chklistData, axiosConfig)
                .then((response) => {
                    history.push({
                        pathname: '/menu/crc-checklist',
                        state: { statusIDValue },
                    });
                })
                .catch((error) => {
                    if (error.response.data.message === 'Checklist Id or Service Id does not exist or stage mis-match') {
                        openConfirmationDialogForItecCRC();
                    } else {
                        setpopUpDisplayMessage(error.response.data.message);
                        setpopUpDisplayType('error');
                        handleClick();
                    }
                });
        }
        if (actionButtonData.statusId === 4) {
            userType.value = 'L1 CRC Confirmed';
            userType.historyStageId = 5;
            history.push({
                pathname: '/menu/crc-checklist',
                state: { statusIDValue },
            });
        }
        if (actionButtonData.statusId === 5) {
            userType.value = 'L1 AM Confirmed';
            axios
                .get(`${CommonConfig.dev.baseUrl}/api/auth/services/${selectedImc}?page=0&size=10000`, axiosConfig)
                .then((response) => {
                    response.data.content.filter((dataValue, i) => {
                        if (dataValue.serviceId === serviceIdSelected) {
                            if (dataValue.checkList.amPickerEmail === null || dataValue.checkList.amPickerEmail === username) {
                                const data = {
                                    serviceId: serviceIdSelected,
                                };
                                // userType.value = 'L2 Checklist';
                                axios
                                    .post(
                                        `${CommonConfig.dev.baseUrl1}/api/itr/checklist/updateAMDetails/${imcNameSelected}`,
                                        data,
                                        axiosConfig
                                    )
                                    .then((response) => {
                                        if (response.data === 'SUCCESS') {
                                            history.push({
                                                pathname: '/menu/crc-checklist',
                                                state: { serviceIdSelected },
                                            });
                                        }
                                    })
                                    .catch(() => {});
                            } else {
                                setAMPickerName(dataValue.checkList.amPickerFirstName);
                                openConfirmationDialogForItecAM();
                            }
                        }
                    });
                })
                .catch(() => {});
        }
        if (actionButtonData.statusId === 8) {
            userType.value = 'L2 CRC Confirmed';
            history.push({
                pathname: '/menu/crc-checklist',
                state: { statusIDValue },
            });
        }
        if (actionButtonData.statusId === 10) {
            userType.value = 'EM Confirmed';
            history.push({
                pathname: '/menu/crc-checklist',
                state: { statusIDValue },
            });
        }

        if (actionButtonData.statusId === 11) {
            setIsOpen(true);
            // history.push('/menu/openservice');
        }
        if (actionButtonData.statusId === 12) {
            userType.value = 'Detailed Analysis';
            axios
                .put(`${CommonConfig.dev.baseUrl1}/api/itr/detailed-analysis/others-pick/${imcNameSelected}/${serviceIdSelected}`, '', {
                    headers: {
                        Authorization: bearerToken,
                    },
                })
                .then((response) => {
                    if (response.status === 200) {
                        axios
                            .get(
                                `${CommonConfig.dev.baseUrl1}/api/itr/detailed-analysis/by-serviceId/${imcNameSelected}/${serviceIdSelected}`,
                                {
                                    headers: {
                                        Authorization: bearerToken,
                                    },
                                }
                            )
                            .then((response) => {
                                const emailItecothers = response.data.assigedUsers[0];
                                const emailAssigned = emailItecothers.employeeEmailId;
                                const employeeFirstName = emailItecothers.employeeFirstName + ' ' + emailItecothers.employeeLastName;
                                const employeeLastName = emailItecothers.employeeLastName;
                                setItecOthersPickerName(employeeFirstName, employeeLastName);
                                if (emailAssigned === username) {
                                    history.push('/menu/itec-detail-analysis-crc');
                                } else {
                                    openConfirmationDialogForItecOthers();
                                }
                            })
                            .catch(() => {});
                    }
                })
                .catch(() => {});
        }
        if (actionButtonData.statusId === 13) {
            if (userTeam === 'Team') {
                if (branchName === 'Other employee users') {
                    history.push('/menu/detail-analysis');
                }
                if (branchName === 'EM') {
                    axios
                        .get(
                            `${CommonConfig.dev.baseUrl1}/api/itr/detailed-analysis/by-serviceId-em/${imcNameSelected}/${serviceIdSelected}`,
                            {
                                headers: {
                                    Authorization: bearerToken,
                                },
                            }
                        )
                        .then((response) => {
                            if (response.status === 200) {
                                history.push('/menu/detail-analysis');
                            }
                        })
                        .catch((error) => {
                            const errors = error.response;
                            const StageIDMismatch = errors && errors.data;
                            if (StageIDMismatch.message === 'StageID Mismatch') {
                                openConfirmationDialog();
                            }
                        });
                }
            } else {
                axios
                    .get(`${CommonConfig.dev.baseUrl1}/api/itr/detailed-analysis/by-serviceId-am/${imcNameSelected}/${serviceIdSelected}`, {
                        headers: {
                            Authorization: bearerToken,
                        },
                    })
                    .then((response) => {
                        if (response.status === 200) {
                            history.push('/menu/itec-detail-analysis-am');
                        }
                    })
                    .catch((error) => {
                        const errors = error.response;
                        const StageIDMismatch = errors && errors.data;
                        if (StageIDMismatch.message === 'StageID Mismatch') {
                            openConfirmationDialog();
                        }
                    });
            }
        }
        if (actionButtonData.statusId === 15) {
            userType.value = 'Detailed Analysis';
            history.push('/menu/itec-detail-analysis-am');
        }
        if (actionButtonData.statusId === 14) {
            userType.value = 'Detailed Analysis';
            history.push('/menu/detail-analysis');
        }
        if (actionButtonData.statusId === 16 || actionButtonData.statusId === 18) {
            userType.value = 'Draft Statements';
            history.push({
                pathname: '/menu/imc-draft-document',
                state: { path: 'openservices' },
            });
        }
        if (actionButtonData.statusId === 19) {
            userType.value = 'Final Statement';
            history.push('/menu/imc-tax-payment');
        }
        if (actionButtonData.statusId === 21) {
            userType.value = 'Tax Payment and Filing';
            history.push('/menu/imc-final-doc-approval');
        }
        if (actionButtonData.statusId === 22) {
            userType.value = 'Reports';
            history.push('/menu/request-invoice');
        }
        if (actionButtonData.statusId === 23) {
            history.push('/menu/indInvoice');
        }
    };

    const getStatus = (data) => {
        // console.log("111", data.taxPaid);
        // console.log("111", data.taskpickerdetails.crcPickerLastName);
        // console.log("111", data.taskpickerdetails.crcPickerFirstName);
        // console.log('data.servId', data.serviceTypeText);
        if (data.Statusid === 1) {
            if (userTeam === 'ITeC Team') {
                if (branchName === 'ITeC AM and above' || branchName === 'SuperAdmin') {
                    return <>{data.chklstData.stageText}</>;
                } else if (branchName === 'ITeC Team' || branchName === 'SuperAdmin') {
                    return <>{data.chklstData.stageText}</>;
                }
            } else if (userTeam === 'Team') {
                if (branchName === 'EM') {
                    return (
                        <button
                            className="checklistBtn-openService"
                            onClick={() =>
                                actionButton({ statusId: data.Statusid, servId: data.servId, serviceTypeText: data.serviceTypeText })
                            }
                        >
                            {data.serviceTypeText === 'INCORPORATION' ? 'View' : 'Generate CheckList L1'}
                        </button>
                    );
                } else if (branchName === 'Other employee users' || branchName === 'Support Team' || branchName === 'Admin') {
                    return <>{data.chklstData.stageText}</>;
                }
            }
        } else if (data.Statusid === 2) {
            if (userTeam === 'ITeC Team') {
                if (branchName === 'ITeC AM and above' || branchName === 'SuperAdmin') {
                    return <>{data.chklstData.stageText}</>;
                } else if (branchName === 'ITeC Team' || branchName === 'SuperAdmin') {
                    return <>{data.chklstData.stageText}</>;
                }
            } else if (userTeam === 'Team') {
                if (branchName === 'EM' || branchName === 'Admin') {
                    return <>{data.chklstData.stageText}</>;
                } else if (branchName === 'Other employee users' || branchName === 'Support Team') {
                    return <>{data.chklstData.stageText}</>;
                }
            }
        } else if (data.Statusid === 3) {
            if (userTeam === 'ITeC Team') {
                if (branchName === 'ITeC AM and above' || branchName === 'SuperAdmin') {
                    return <>{data.chklstData.stageText}</>;
                } else if (branchName === 'ITeC Team') {
                    return (
                        <button
                            className="checklistBtn-openService"
                            onClick={() => actionButton({ statusId: data.Statusid, servId: data.servId })}
                        >
                            Review L1 by CRC
                        </button>
                    );
                }
            } else if (userTeam === 'Team') {
                if (branchName === 'EM' || branchName === 'Admin') {
                    return <>{data.chklstData.stageText}</>;
                } else if (branchName === 'Other employee users' || branchName === 'Support Team') {
                    return <>{data.chklstData.stageText}</>;
                }
            }
        } else if (data.Statusid === 4) {
            if (userTeam === 'ITeC Team') {
                if (branchName === 'ITeC AM and above' || branchName === 'SuperAdmin') {
                    return <>{data.chklstData.stageText}</>;
                } else if (branchName === 'ITeC Team') {
                    if (data.taskpickerdetails.crcTaskPickerEmail === username) {
                        return (
                            <button
                                className="checklistBtn-openService"
                                onClick={() =>
                                    actionButton({
                                        statusId: data.Statusid,
                                        servId: data.servId,
                                        taskpickerdetailsfromstageID4: data.taskpickerdetails,
                                    })
                                }
                            >
                                Review L1 by CRC
                            </button>
                        );
                    } else {
                        return <>{data.chklstData.stageText}</>;
                    }
                }
            } else if (userTeam === 'Team') {
                if (branchName === 'EM' || branchName === 'Admin') {
                    return <>{data.chklstData.stageText}</>;
                } else if (branchName === 'Other employee users' || branchName === 'Support Team') {
                    return <>{data.chklstData.stageText}</>;
                }
            }
        } else if (data.Statusid === 5) {
            if (userTeam === 'ITeC Team') {
                if (branchName === 'ITeC AM and above') {
                    if (data.taskpickerdetails.amPickerEmail === null) {
                        return (
                            <button
                                className="checklistBtn-openService"
                                onClick={() =>
                                    actionButton({
                                        statusId: data.Statusid,
                                        servId: data.servId,
                                        taskpickerdetailsfromstageID5: data.taskpickerdetails,
                                    })
                                }
                            >
                                Review L1 by ITeC AM
                            </button>
                        );
                    } else if (data.taskpickerdetails.amPickerEmail === username) {
                        return (
                            <button
                                className="checklistBtn-openService"
                                onClick={() =>
                                    actionButton({
                                        statusId: data.Statusid,
                                        servId: data.servId,
                                        taskpickerdetailsfromstageID5: data.taskpickerdetails,
                                    })
                                }
                            >
                                Review L1 by ITeC AM
                            </button>
                        );
                    } else {
                        return <>{data.chklstData.stageText}</>;
                    }
                } else if (branchName === 'ITeC Team' || branchName === 'SuperAdmin') {
                    return <>{data.chklstData.stageText}</>;
                }
            } else if (userTeam === 'Team') {
                if (branchName === 'EM' || branchName === 'Admin') {
                    return <>{data.chklstData.stageText}</>;
                } else if (branchName === 'Other employee users' || branchName === 'Support Team') {
                    return <>{data.chklstData.stageText}</>;
                }
            }
        } else if (data.Statusid === 6) {
            if (userTeam === 'ITeC Team') {
                if (branchName === 'ITeC AM and above' || branchName === 'SuperAdmin') {
                    return <>{data.chklstData.stageText}</>;
                } else if (branchName === 'ITeC Team' || branchName === 'SuperAdmin') {
                    return <>{data.chklstData.stageText}</>;
                }
            } else if (userTeam === 'Team') {
                if (branchName === 'EM' || branchName === 'Admin') {
                    return <>{data.chklstData.stageText}</>;
                } else if (branchName === 'Other employee users' || branchName === 'Support Team') {
                    return <>{data.chklstData.stageText}</>;
                }
            }
        } else if (data.Statusid === 7) {
            if (userTeam === 'ITeC Team') {
                if (branchName === 'ITeC AM and above' || branchName === 'SuperAdmin') {
                    return <>{data.chklstData.stageText}</>;
                } else if (branchName === 'ITeC Team') {
                    return (
                        <button
                            className="checklistBtn-openService"
                            onClick={() => actionButton({ statusId: data.Statusid, servId: data.servId })}
                        >
                            L2 Review-CRC
                        </button>
                    );
                }
            } else if (userTeam === 'Team') {
                if (branchName === 'EM' || branchName === 'Admin') {
                    return <>{data.chklstData.stageText}</>;
                } else if (branchName === 'Other employee users' || branchName === 'Support Team') {
                    return <>{data.chklstData.stageText}</>;
                }
            }
        } else if (data.Statusid === 8) {
            if (userTeam === 'ITeC Team') {
                if (branchName === 'ITeC AM and above' || branchName === 'SuperAdmin') {
                    return <>{data.chklstData.stageText}</>;
                } else if (branchName === 'ITeC Team') {
                    if (data.taskpickerdetails.crcTaskPickerEmail === username) {
                        return (
                            <button
                                className="checklistBtn-openService"
                                onClick={() => actionButton({ statusId: data.Statusid, servId: data.servId })}
                            >
                                L2 Review started-CRC
                            </button>
                        );
                    } else {
                        return <>{data.chklstData.stageText}</>;
                    }
                }
            } else if (userTeam === 'Team') {
                if (branchName === 'EM' || branchName === 'Admin') {
                    return <>{data.chklstData.stageText}</>;
                } else if (branchName === 'Other employee users' || branchName === 'Support Team') {
                    return <>{data.chklstData.stageText}</>;
                }
            }
        } else if (data.Statusid === 10) {
            if (userTeam === 'ITeC Team') {
                if (branchName === 'ITeC AM and above' || branchName === 'SuperAdmin') {
                    return <>{data.chklstData.stageText}</>;
                } else if (branchName === 'ITeC Team' || branchName === 'SuperAdmin') {
                    return <>{data.chklstData.stageText}</>;
                }
            } else if (userTeam === 'Team') {
                if (branchName === 'EM' || branchName === 'Other employee users') {
                    return (
                        <button
                            className="checklistBtn-openService"
                            onClick={() => actionButton({ statusId: data.Statusid, servId: data.servId })}
                        >
                            Review CRC L1/L2 by EM
                        </button>
                    );
                } else if (branchName === 'Support Team' || branchName === 'Admin') {
                    return <>{data.chklstData.stageText}</>;
                }
            }
        } else if (data.Statusid === 11) {
            if (userTeam === 'ITeC Team') {
                if (branchName === 'ITeC AM and above') {
                    return (
                        <>
                            <button
                                className="checklistBtn-openService"
                                onClick={() => actionButton({ statusId: data.Statusid, servId: data.servId })}
                            >
                                Assign(Detail Analysis)
                            </button>
                            <MyModal isOpen={isOpen} handleCloseDialog={handleCloseDialog} itecUsers={ItecUsers} />
                        </>
                    );
                } else if (branchName === 'ITeC Team') {
                    return <>{data.chklstData.stageText}</>;
                }
            } else if (userTeam === 'Team') {
                if (branchName === 'EM' || branchName === 'Admin') {
                    return <>{data.chklstData.stageText}</>;
                } else if (branchName === 'Other employee users' || branchName === 'Support Team') {
                    return <>{data.chklstData.stageText}</>;
                }
            }
        } else if (data.Statusid === 12) {
            if (userTeam === 'ITeC Team') {
                if (branchName === 'ITeC AM and above' || branchName === 'SuperAdmin') {
                    return <>{data.chklstData.stageText}</>;
                } else if (branchName === 'ITeC Team') {
                    return (
                        <button
                            className="checklistBtn-openService"
                            onClick={() => actionButton({ statusId: data.Statusid, servId: data.servId })}
                        >
                            Detail Analysis
                        </button>
                    );
                }
            } else if (userTeam === 'Team') {
                if (branchName === 'EM' || branchName === 'Admin') {
                    return <>{data.chklstData.stageText}</>;
                } else if (branchName === 'Other employee users' || branchName === 'Support Team') {
                    return <>{data.chklstData.stageText}</>;
                }
            }
        } else if (data.Statusid === 13) {
            if (userTeam === 'ITeC Team') {
                if (branchName === 'ITeC AM and above') {
                    return (
                        <button
                            className="checklistBtn-openService"
                            onClick={() => actionButton({ statusId: data.Statusid, servId: data.servId })}
                        >
                            Review DA
                        </button>
                    );
                } else if (branchName === 'ITeC Team' || branchName === 'SuperAdmin') {
                    return <>{data.chklstData.stageText}</>;
                }
            } else if (userTeam === 'Team') {
                if (branchName === 'EM' || branchName === 'Other employee users') {
                    return (
                        <button
                            className="checklistBtn-openService"
                            onClick={() => actionButton({ statusId: data.Statusid, servId: data.servId })}
                        >
                            Review DA
                        </button>
                    );
                } else if (branchName === 'Support Team' || branchName === 'Admin') {
                    return <>{data.chklstData.stageText}</>;
                }
            }
        } else if (data.Statusid === 14) {
            if (userTeam === 'ITeC Team') {
                if (branchName === 'ITeC AM and above' || branchName === 'SuperAdmin') {
                    return <>{data.chklstData.stageText}</>;
                } else if (branchName === 'ITeC Team' || branchName === 'SuperAdmin') {
                    return <>{data.chklstData.stageText}</>;
                }
            } else if (userTeam === 'Team') {
                if (branchName === 'EM' || branchName === 'Other employee users') {
                    return (
                        <button
                            className="checklistBtn-openService"
                            onClick={() => actionButton({ statusId: data.Statusid, servId: data.servId })}
                        >
                            Review DA by EM
                        </button>
                    );
                } else if (branchName === 'Support Team' || branchName === 'Admin') {
                    return <>{data.chklstData.stageText}</>;
                }
            }
        } else if (data.Statusid === 15) {
            if (userTeam === 'ITeC Team') {
                if (branchName === 'ITeC AM and above') {
                    return (
                        <button
                            className="checklistBtn-openService"
                            onClick={() => actionButton({ statusId: data.Statusid, servId: data.servId })}
                        >
                            Review DA by ITeC AM
                        </button>
                    );
                } else if (branchName === 'ITeC Team' || branchName === 'SuperAdmin') {
                    return <>{data.chklstData.stageText}</>;
                }
            } else if (userTeam === 'Team') {
                if (branchName === 'EM' || branchName === 'Admin') {
                    return <>{data.chklstData.stageText}</>;
                } else if (branchName === 'Other employee users' || branchName === 'Support Team') {
                    return <>{data.chklstData.stageText}</>;
                }
            }
        } else if (data.Statusid === 16 || data.Statusid === 18) {
            if (userTeam === 'ITeC Team') {
                if (branchName === 'ITeC AM and above' || branchName === 'SuperAdmin') {
                    return <>{data.chklstData.stageText}</>;
                } else if (branchName === 'ITeC Team' || branchName === 'SuperAdmin') {
                    return <>{data.chklstData.stageText}</>;
                }
            } else if (userTeam === 'Team') {
                if (branchName === 'EM' || branchName === 'Other employee users') {
                    return (
                        <button
                            className="checklistBtn-openService"
                            onClick={() => actionButton({ statusId: data.Statusid, servId: data.servId })}
                        >
                            {/* Drafting Under EM */}
                            {data.Statusid === 16 ? 'Draft Statements' : 'Rework on Draft statements'}
                        </button>
                    );
                } else if (branchName === 'Support Team' || branchName === 'Admin') {
                    return <>{data.chklstData.stageText}</>;
                }
            }
        } else if (data.Statusid === 17) {
            if (userTeam === 'ITeC Team') {
                if (branchName === 'ITeC AM and above' || branchName === 'SuperAdmin') {
                    return <>{data.chklstData.stageText}</>;
                } else if (branchName === 'ITeC Team' || branchName === 'SuperAdmin') {
                    return <>{data.chklstData.stageText}</>;
                }
            } else if (userTeam === 'Team') {
                if (branchName === 'EM' || branchName === 'Admin') {
                    return <>{data.chklstData.stageText}</>;
                } else if (branchName === 'Other employee users' || branchName === 'Support Team') {
                    return <>{data.chklstData.stageText}</>;
                }
            }
        } else if (data.Statusid === 18) {
            if (userTeam === 'ITeC Team') {
                if (branchName === 'ITeC AM and above' || branchName === 'SuperAdmin') {
                    return <>{data.chklstData.stageText}</>;
                } else if (branchName === 'ITeC Team' || branchName === 'SuperAdmin') {
                    return <>{data.chklstData.stageText}</>;
                }
            } else if (userTeam === 'Team') {
                if (branchName === 'EM' || branchName === 'Admin') {
                    return <>{data.chklstData.stageText}</>;
                } else if (branchName === 'Other employee users' || branchName === 'Support Team') {
                    return <>{data.chklstData.stageText}</>;
                }
            }
        } else if (data.Statusid === 19) {
            if (userTeam === 'ITeC Team') {
                if (branchName === 'ITeC AM and above' || branchName === 'SuperAdmin') {
                    return <>{data.chklstData.stageText}</>;
                } else if (branchName === 'ITeC Team' || branchName === 'SuperAdmin') {
                    return <>{data.chklstData.stageText}</>;
                }
            } else if (userTeam === 'Team') {
                if (branchName === 'EM' || branchName === 'Other employee users') {
                    return (
                        <button
                            className="checklistBtn-openService"
                            onClick={() => actionButton({ statusId: data.Statusid, servId: data.servId })}
                        >
                            {/* Final Comp. Under EM */}
                            {/* Tax Payment Under EM */}
                            Upload Final Statements
                        </button>
                    );
                } else if (branchName === 'Support Team' || branchName === 'Admin') {
                    return <>{data.chklstData.stageText}</>;
                }
            }
        } else if (data.Statusid === 20) {
            if (userTeam === 'ITeC Team') {
                if (branchName === 'ITeC AM and above' || branchName === 'SuperAdmin') {
                    return <>{data.chklstData.stageText}</>;
                } else if (branchName === 'ITeC Team' || branchName === 'SuperAdmin') {
                    return <>{data.chklstData.stageText}</>;
                }
            } else if (userTeam === 'Team') {
                if (branchName === 'EM' || branchName === 'Admin') {
                    return <>{data.chklstData.stageText}</>;
                } else if (branchName === 'Other employee users' || branchName === 'Support Team') {
                    return <>{data.chklstData.stageText}</>;
                }
            }
        } else if (data.Statusid === 21) {
            if (userTeam === 'ITeC Team') {
                if (branchName === 'ITeC AM and above' || branchName === 'SuperAdmin') {
                    return <>{data.chklstData.stageText}</>;
                } else if (branchName === 'ITeC Team' || branchName === 'SuperAdmin') {
                    return <>{data.chklstData.stageText}</>;
                }
            } else if (userTeam === 'Team') {
                if (branchName === 'EM' || branchName === 'Other employee users') {
                    return (
                        <button
                            className="checklistBtn-openService"
                            onClick={() => actionButton({ statusId: data.Statusid, servId: data.servId })}
                        >
                            {/* ITR Payment Confirmation-Client
                             */}
                            {/* Submit ITR */}

                            {data.taxPaid === null || data.taxPaid === true ? 'Submit ITR' : 'Pay tax or Submit ITR'}
                        </button>
                    );
                } else if (branchName === 'Support Team' || branchName === 'Admin') {
                    return <>{data.chklstData.stageText}</>;
                }
            }
        } else if (data.Statusid === 22) {
            if (userTeam === 'ITeC Team') {
                if (branchName === 'ITeC AM and above' || branchName === 'SuperAdmin') {
                    return <>{data.chklstData.stageText}</>;
                } else if (branchName === 'ITeC Team' || branchName === 'SuperAdmin') {
                    return <>{data.chklstData.stageText}</>;
                }
            } else if (userTeam === 'Team') {
                if (branchName === 'EM' || branchName === 'Other employee users') {
                    return (
                        <button
                            className="checklistBtn-openService"
                            onClick={() => actionButton({ statusId: data.Statusid, servId: data.servId })}
                        >
                            {/* Generate Report-EM
                             */}
                            Request for Invoice
                        </button>
                    );
                } else if (branchName === 'Support Team' || branchName === 'Admin') {
                    return <>{data.chklstData.stageText}</>;
                }
            }
        } else if (data.Statusid === 23) {
            if (userTeam === 'ITeC Team') {
                if (branchName === 'ITeC AM and above' || branchName === 'SuperAdmin') {
                    return <>{data.chklstData.stageText}</>;
                } else if (branchName === 'ITeC Team' || branchName === 'SuperAdmin') {
                    return <>{data.chklstData.stageText}</>;
                }
            } else if (userTeam === 'Team') {
                // if (branchName === 'Support Team' || branchName === 'Admin') {
                //     return (
                //         <button
                //             className="checklistBtn-openService"
                //             onClick={() => actionButton({ statusId: data.Statusid, servId: data.servId })}
                //         >
                //             Invoice Generation - EM
                //         </button>
                //     );
                // } else if (branchName === 'Other employee users' || branchName === 'Support Team' || branchName === 'EM' || branchName === 'Admin') {
                //     return <>{data.chklstData.stageText}</>;
                // }
                return <>{data.chklstData.stageText}</>;
            }
        } else if (data.Statusid === 24) {
            if (userTeam === 'ITeC Team') {
                if (branchName === 'ITeC AM and above' || branchName === 'SuperAdmin') {
                    return <>{data.chklstData.stageText}</>;
                } else if (branchName === 'ITeC Team' || branchName === 'SuperAdmin') {
                    return <>{data.chklstData.stageText}</>;
                }
            } else if (userTeam === 'Team') {
                if (branchName === 'EM' || branchName === 'Admin') {
                    return <>{data.chklstData.stageText}</>;
                } else if (branchName === 'Other employee users' || branchName === 'Support Team') {
                    return <>{data.chklstData.stageText}</>;
                }
            }
        } else if (data.Statusid === 25) {
            if (userTeam === 'ITeC Team') {
                if (branchName === 'ITeC AM and above' || branchName === 'SuperAdmin') {
                    // return <>{data.chklstData.stageText}</>;
                    return <>Payment Confirmation</>;
                } else if (branchName === 'ITeC Team' || branchName === 'SuperAdmin') {
                    // return <>{data.chklstData.stageText}</>;
                    return <>Payment Confirmation</>;
                }
            } else if (userTeam === 'Team') {
                if (branchName === 'EM' || branchName === 'Admin') {
                    // return <>{data.chklstData.stageText}</>;
                    return <>Payment Confirmation</>;
                } else if (branchName === 'Other employee users' || branchName === 'Support Team') {
                    // return <>{data.chklstData.stageText}</>;
                    return <>Payment Confirmation</>;
                }
            }
        }

        // else if (data.Statusid === 27) {
        //     if (userTeam === 'ITeC Team') {
        //         if (branchName === 'SuperAdmin') {
        //             return <>{data.chklstData.stageText}</>;
        //         }
        //         // else if (branchName === 'ITeC Team' || branchName === 'SuperAdmin') {
        //         //     return <>{data.chklstData.stageText}</>;
        //         // }
        //     }
        // else if (userTeam === 'Team') {
        // if (branchName === 'EM' || branchName === 'Admin') {
        //     return <>{data.chklstData.stageText}</>;
        // } else if (branchName === 'Other employee users' || branchName === 'Support Team') {
        //     return <>{data.chklstData.stageText}</>;
        // }
        // }
        // }
        else if (data.Statusid === 26) {
            if (userTeam === 'ITeC Team') {
                if (branchName === 'ITeC AM and above' || branchName === 'SuperAdmin') {
                    return <>{data.chklstData.stageText}</>;
                } else if (branchName === 'ITeC Team' || branchName === 'SuperAdmin') {
                    return <>{data.chklstData.stageText}</>;
                }
            } else if (userTeam === 'Team') {
                if (branchName === 'EM' || branchName === 'Admin') {
                    return <>{data.chklstData.stageText}</>;
                } else if (branchName === 'Other employee users' || branchName === 'Support Team') {
                    return <>{data.chklstData.stageText}</>;
                }
            }
        } else if (data.Statusid === 30) {
            if (userTeam === 'ITeC Team') {
                if (branchName === 'SuperAdmin') {
                    return <>{data.chklstData.stageText}</>;
                }
                // else if (branchName === 'ITeC Team' || branchName === 'SuperAdmin') {
                //     return <>{data.chklstData.stageText}</>;
                // }
            }
            // else if (userTeam === 'Team') {
            // if (branchName === 'EM' || branchName === 'Admin') {
            //     return <>{data.chklstData.stageText}</>;
            // } else if (branchName === 'Other employee users' || branchName === 'Support Team') {
            //     return <>{data.chklstData.stageText}</>;
            // }
            // }
        } else if (data.Statusid === 31) {
            if (userTeam === 'ITeC Team') {
                if (branchName === 'ITeC AM and above' || branchName === 'SuperAdmin') {
                    return <>{data.chklstData.stageText}</>;
                } else if (branchName === 'ITeC Team' || branchName === 'SuperAdmin') {
                    return <>{data.chklstData.stageText}</>;
                }
            } else if (userTeam === 'Team') {
                if (branchName === 'EM' || branchName === 'Admin') {
                    // return <>{data.chklstData.stageText}</>;
                    return <>Invoice Generated</>;
                } else if (branchName === 'Other employee users' || branchName === 'Support Team') {
                    // return <>{data.chklstData.stageText}</>;
                    return <>Invoice Generated</>;
                }
            }
        }
    };

    const rowData = (rowdata, serviceType) => {
        return headcells.map((col) => {
            let tabledata;
            const statusId = rowdata.statusId;
            const checkList = rowdata.checkList ? rowdata.checkList.currentStage : '';
            if (col.id === 'statusId' && serviceType === 'open' && checkList.id !== 0) {
                // console.log("taxPaid", rowdata.checkList.taxPaid);
                tabledata = (
                    <TableCell style={{ fontFamily: 'Rubik' }} align="left" key={col.id}>
                        {getStatus({
                            Statusid: checkList.id,
                            servId: rowdata['serviceId'],
                            chklstData: checkList,
                            taskpickerdetails: rowdata.checkList,
                            taxPaid: rowdata.checkList.taxPaid,
                            serviceTypeText: rowdata.servicetypeId.servicetypeText,
                        })}
                    </TableCell>
                );
            } else {
                if (col.isConcat && rowdata[col.id]) {
                    const subdata = rowdata[col.id];
                    const mergedData = col.concatElem.map((concatdata) => {
                        return concatdata.split('.').reduce((acc, item) => {
                            if (Object.prototype.hasOwnProperty.call(acc, item)) {
                                return acc[item];
                            }
                            return '';
                        }, subdata);
                    });
                    return (
                        <TableCell style={{ fontFamily: 'Rubik' }} align="left" key={col.id}>
                            {mergedData.join(' ')}
                        </TableCell>
                    );
                }
                tabledata = (
                    <TableCell style={{ fontFamily: 'Rubik' }} align="left" key={col.id}>
                        {rowdata[col.id]}
                    </TableCell>
                );
            }
            return tabledata;
        });
    };

    const pagination = (propsPagination) => {
        handleCount(propsPagination);
    };

    const pagin = () => {
        const pag = (
            <div style={{ float: 'right', padding: ' 16px', display: 'flex', alignItems: 'baseline' }}>
                <div style={{ marginLeft: '10px', paddingBottom: '6px' }}>
                    Showing {pageDetails && pageDetails.number + 1} of {pageDetails && pageDetails.totalPages} Pages
                </div>
                {pageDetails && pageDetails.totalPages > 1 ? (
                    <>
                        <button className="checklistBtn-openService PNButton" onClick={() => pagination('prev')} disabled={prvnxtbt.prvBt}>
                            Previous
                        </button>

                        <button className="checklistBtn-openService PNButton" onClick={() => pagination('next')} disabled={prvnxtbt.nxtBt}>
                            Next
                        </button>
                    </>
                ) : (
                    ''
                )}
            </div>
        );
        return pag;
    };

    useEffect(() => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/get-itecothers?page=0&size=1000`, axiosConfig)
            .then((response) => {
                setItecUsers(response);
            })
            .catch(() => {});

        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/s_itec_employee?page=0&size=10000`, axiosConfig)
            .then((response) => {
                setItecMembers(response.data.content);
            })
            .catch(() => {});

        // axios
        //     .get(`${CommonConfig.dev.baseUrl1}/api/itr/final-computation/by-serviceId/${imcNameSelected}/${serviceIdSelected}`, {
        //         headers: {
        //             Authorization: bearerToken,
        //         },
        //     })
        //     .then((response) => {
        //         console.log("responseIMC", response);
        //         setPaidTax(response.data.paidTax);
        //     })
        //     .catch(() => { });
    }, [userDetails]);

    return (
        <div className={classes.root}>
            <Paper className={classes.paper}>
                <TableContainer>
                    <Table className={classes.table} aria-labelledby="tableTitle" aria-label="enhanced table" size="medium">
                        <EnhancedTableHead
                            classes={classes}
                            headcells={headcells}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={handleRequestSort}
                            action={action}
                            Reports={Reports}
                        />
                        <TableBody style={{ fontFamily: 'Rubik' }}>
                            {stableSort(rows, getComparator(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row, index) => {
                                    const rowDataShow = rowData(row, service);
                                    let slno = 1;
                                    if (page > 0) {
                                        slno = rowsPerPage * page + 1;
                                    }
                                    slno += index;

                                    return (
                                        <TableRow
                                            hover
                                            tabIndex={-1}
                                            key={slno}
                                            className={classes.tableRow}
                                            onClick={() => handleClickRow(row)}
                                        >
                                            {rowDataShow}

                                            {usertype === 'itec' || usertypeBranchName === 'Other employee users'
                                                ? ''
                                                : action && (
                                                      <TableCell align="left" className={classes.tblAction}>
                                                          <FormDialog
                                                              row={row}
                                                              pageName={pageName}
                                                              show="editIcon"
                                                              selectedImc={selectedImc}
                                                          />
                                                          <CommentDeleting
                                                              row={row}
                                                              post={post}
                                                              deleteRow={handleDelete}
                                                              comments
                                                              selectedImc={selectedImc}
                                                          />
                                                      </TableCell>
                                                  )}

                                            {usertype === 'SUPERADMIN' ||
                                            usertype === 'ITeC AM and above' ||
                                            usertype === 'ITeC Team' ||
                                            usertype === 'itec'
                                                ? ''
                                                : Reports && (
                                                      <TableCell align="left">
                                                          <div>
                                                              <Download Icon="download" row={row} />
                                                          </div>
                                                      </TableCell>
                                                  )}
                                        </TableRow>
                                    );
                                })}
                            {emptyRows > 0 && <></>}
                        </TableBody>
                    </Table>
                </TableContainer>
                {pagin()}
            </Paper>
            <Snackbar open={open} autoHideDuration={10000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={popUpDisplayType}>
                    {popUpDisplayMessage}
                </Alert>
            </Snackbar>
            <Dialog
                open={open1}
                onClose={closeConfirmationDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle className={classes.textSize} id="alert-dialog-title">
                    {' '}
                    {branchName === 'EM'
                        ? 'This service is under review by ITeC-AM for further processing'
                        : 'This service is under review by EM for further processing'}{' '}
                </DialogTitle>
                <DialogActions>
                    <Button onClick={closeConfirmationDialog} color="primary" variant="contained" className={classes.button}>
                        Ok
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={OpenForItecAM}
                onClose={closeConfirmationDialogForItecAM}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                {branchName === 'ITeC AM and above' ? (
                    <DialogTitle className={classes.textSizeforcrc} id="alert-dialog-title">
                        This service is under review by {amPickerName} for further processing.
                    </DialogTitle>
                ) : (
                    ''
                )}
                <DialogActions>
                    <Button onClick={closeConfirmationDialogForItecAM} color="primary" variant="contained" className={classes.button}>
                        Ok
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={OpenForItecCRC}
                onClose={closeConfirmationDialogForItecCRC}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                {branchName === 'ITeC Team' ? (
                    <DialogTitle className={classes.textSizeforcrc} id="alert-dialog-title">
                        This service is under review by {crcPickerName} for further processing.
                    </DialogTitle>
                ) : (
                    ''
                )}
                <DialogActions>
                    <Button onClick={closeConfirmationDialogForItecCRC} color="primary" variant="contained" className={classes.button}>
                        Ok
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={OpenForItecOthers}
                onClose={closeConfirmationDialogForItecOthers}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle className={classes.textSizeforcrc} id="alert-dialog-title">
                    This service is under review by {itecOthersPickerName} for further processing.
                </DialogTitle>
                <DialogActions>
                    <Button onClick={closeConfirmationDialogForItecOthers} color="primary" variant="contained" className={classes.button}>
                        Ok
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default ServiceTable;
